import { Button } from '../ui/button'
// @ts-strict-ignore
import React, { useMemo, useState } from 'react'
import { format } from 'date-fns'
import { BugFixBadge, FeatureBadge, UpdateBadge } from './badges'
const sortByDate = (a, b) => {
    if (a.date === b.date) {
        return 0
    }

    return a.date > b.date ? -1 : 1
}

export const ChangeOverview = ({ title, date, updates, children }) => {
    const [showDetail, setShowDetail] = useState<boolean>(false)

    const { featureCount, updateCount, bugFixCount, featuresList, updatesList, bugFixesList } =
        useMemo(() => {
            let bugFixCount = 0
            let updateCount = 0
            let featureCount = 0
            let totalCount = 0

            const featuresList = []
            const updatesList = []
            const bugFixesList = []

            updates.forEach((u) => {
                u.updates.forEach((i) => {
                    totalCount++
                    switch (i.type) {
                        case 'bugfix':
                            bugFixCount++
                            bugFixesList.push({ ...i, date: u.date })
                            break
                        case 'feature':
                            featureCount++
                            featuresList.push({ ...i, date: u.date })
                            break
                        case 'update':
                            updateCount++
                            updatesList.push({ ...i, date: u.date })
                            break
                        default:
                            console.error('invalid type:', i.type, 'in', i)
                    }
                })
            })

            bugFixesList.sort(sortByDate)
            updatesList.sort(sortByDate)
            featuresList.sort(sortByDate)

            return {
                bugFixCount,
                updateCount,
                featureCount,
                totalCount,
                bugFixesList,
                updatesList,
                featuresList,
            }
        }, [updates])

    return (
        <div className="bg-white p-4 rounded-md shadow-md border mb-8 max-w-screen-md w-full">
            <div className="text-gray-400 text-sm mb-2">{format(date, 'LLL do, yyyy')}</div>
            <div className="font-normal text-2xl">{title}</div>
            <div className="mt-4">{children}</div>

            <div>
                <div className="text-xl font-normal mb-3">Overview</div>
                <div className="flex gap-x-4">
                    <FeatureBadge count={featureCount} />
                    <UpdateBadge count={updateCount} />
                    <BugFixBadge count={bugFixCount} />
                </div>
            </div>

            <Button
                className="mt-4"
                outlined
                text={showDetail ? 'Hide Details' : 'View Details'}
                onClick={() => setShowDetail((p) => !p)}
            />

            {showDetail && (
                <div className="border-t mt-4">
                    <Details
                        badge={<FeatureBadge />}
                        list={featuresList}
                        type="features"
                        date={date}
                    />

                    <Details
                        badge={<UpdateBadge />}
                        list={updatesList}
                        type="updates"
                        date={date}
                    />

                    <Details
                        badge={<BugFixBadge />}
                        list={bugFixesList}
                        type="bug-fixes"
                        date={date}
                    />
                </div>
            )}
        </div>
    )
}

const Details = ({ badge, list, date, type }) => {
    return (
        <div className="mt-8">
            {badge}
            <ul className="mt-3 list-disc ml-4">
                {list.map((i, index) => {
                    return (
                        <li key={`${type}-${date}-${index}`}>
                            {i.date} - {i.short_desc}
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}
